import React from 'react';
import { FormattedMessage } from 'react-intl';

import LinkInI18nBlock from 'src/enosikit/components/LinkInI18nBlock';
import { AUTH_ERROR_DEFAULT, AUTH_ERROR_USER_DEACTIVATED } from 'src/util/constants';

const SUPPORT_URL = (intl) => intl.formatMessage({
  id: 'auth.error_messages.auth_error.support.url',
  defaultMessage: 'https://support.enosi.energy/',
});

/**
 * I18n messages shown for deactivated users during authentication error
 * @param {object} intl - intl object
 * @returns {object} Object containing the i18n messages
 */
export const AUTH_ERROR_DEACTIVATED_USER_MESSAGES = (intl) => ({
  pageTitle: intl.formatMessage({
    id: 'auth.error_messages.deactivated_user.page.title',
    defaultMessage: 'Account Deactivated - Enosi',
  }),
  heading: intl.formatMessage({
    id: 'auth.error_messages.deactivated_user.page.heading',
    defaultMessage: 'Account Deactivated',
  }),
  description: (
    <FormattedMessage
      id="auth.error_messages.deactivated_user.page.description"
      defaultMessage="Your user account is deactivated. Please get in touch via <link>our support page</link>."
      values={{
        link: (chunks) => (
          <LinkInI18nBlock
            url={SUPPORT_URL(intl)}
            urlKey="auth.error_messages.deactivated_user.page.description.url"
            chunks={chunks}
          />
        ),
      }}
    />
  ),
  supportUrl: SUPPORT_URL(intl),
});

/**
 * I18n default messages for authentication error
 * @param {object} intl - intl object
 * @returns {object} Object containing the i18n messages
 */
export const AUTH_ERROR_DEFAULT_MESSAGES = (intl) => ({
  pageTitle: intl.formatMessage({
    id: 'auth.error_messages.default.page.title',
    defaultMessage: 'Uhoh, something went wrong...',
  }),
  heading: intl.formatMessage({
    id: 'auth.error_messages.default.page.heading',
    defaultMessage: 'Something went wrong.',
  }),
  description: (
    <FormattedMessage
      id="auth.error_messages.default.page.description"
      defaultMessage="Please reload the page or get in touch via <link>our support page</link>."
      values={{
        link: (chunks) => (
          <LinkInI18nBlock
            url={SUPPORT_URL(intl)}
            urlKey="auth.error_messages.default.page.description.url"
            chunks={chunks}
          />
        ),
      }}
    />
  ),
  supportUrl: SUPPORT_URL(intl),
});

/**
 * Get error messages based on error type
 * @param {object} intl - intl object
 * @param {AUTH_ERROR_USER_DEACTIVATED | AUTH_ERROR_DEFAULT} errorType - Type of error
 * @returns {object} Object containing the appropriate error messages
 */
export const getErrorMessages = (intl, errorType) => {
  if (errorType === AUTH_ERROR_USER_DEACTIVATED) {
    return AUTH_ERROR_DEACTIVATED_USER_MESSAGES(intl);
  }
  return AUTH_ERROR_DEFAULT_MESSAGES(intl);
};
